import React from 'react';
import './index.scss';
import { Header } from 'semantic-ui/semantic-ui-imports';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Login from '../../components/Login';

const LoginPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="login-page">
      <Header color="teal" className="login-page__header">
        {t('loginPage.title')}
      </Header>
      <Login onLoggedIn={() => navigate('/')} />
    </div>
  );
};

export default LoginPage;
